import * as Yup from "yup";

/** Matches Luna `AcceptInviteSchema` / `ResetPasswordVerifySchema` special-character check. */
export const PASSWORD_ALLOWED_SYMBOLS = "!@#$%^&*()-_=+[]{};:,.<>/?`~";

export function passwordHasAllowedSymbol(password: string): boolean {
  for (let i = 0; i < password.length; i += 1) {
    if (PASSWORD_ALLOWED_SYMBOLS.includes(password[i]!)) {
      return true;
    }
  }
  return false;
}

export type PasswordRequirementStatus = {
  minLength: boolean;
  hasDigit: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasSymbol: boolean;
};

export function getPasswordRequirementStatus(
  password: string,
): PasswordRequirementStatus {
  return {
    minLength: password.length >= 8,
    hasDigit: /\d/.test(password),
    hasUppercase: /[A-Z]/.test(password),
    hasLowercase: /[a-z]/.test(password),
    hasSymbol: password.length > 0 && passwordHasAllowedSymbol(password),
  };
}

/** Client-side rules aligned with Luna accept-invite + reset-password verify. */
export const strongPasswordYupField = Yup.string()
  .required("Required")
  .min(8, "At least 8 characters")
  .test("lowercase", "At least one lowercase letter", (value) => {
    if (value == null || value === "") {
      return true;
    }
    return /[a-z]/.test(value);
  })
  .test("uppercase", "At least one uppercase letter", (value) => {
    if (value == null || value === "") {
      return true;
    }
    return /[A-Z]/.test(value);
  })
  .test("digit", "At least one number", (value) => {
    if (value == null || value === "") {
      return true;
    }
    return /\d/.test(value);
  })
  .test("symbol", "At least one symbol (!@#$…)", (value) => {
    if (value == null || value === "") {
      return true;
    }
    return passwordHasAllowedSymbol(value);
  });
